import { render } from "./TelegramSetting.vue?vue&type=template&id=3503f53a"
import script from "./TelegramSetting.vue?vue&type=script&lang=js"
export * from "./TelegramSetting.vue?vue&type=script&lang=js"
script.render = render

export default script